import { render } from "./MaterialPaginationItem.vue?vue&type=template&id=3aa087d6"
import script from "./MaterialPaginationItem.vue?vue&type=script&lang=js"
export * from "./MaterialPaginationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__